import { useState, useEffect } from "react"
import { Link } from 'react-router-dom';

import { getData, setData } from "../helper/localStorage";


const ConfirmRegistration = () => {
  const [loading, setLoading] = useState(true)
    const [btnText, setBtnText] = useState("Submit");
    const [userId, setUserId] = useState('')

    useEffect(() => {
        let conf = "/approved/";
        const path = window.location.pathname;
        if(path.includes(conf)) {
            
            let userIdValue = path.replace(conf,'');
          setUserId(userIdValue.slice(0,24))

          setData("userId", userIdValue.slice(0,24))
          setLoading(false)
          }
         
         
        
        
    }, [])

    const handleClick = ()=>{
        setBtnText("Submitting....please wait")
        alert(`user id :  ${userId}`)
        window.location=`/user/${userId}`
        // axios.get(`https://bizfizbe.herokuapp.com/getdatasession?userid=${userId}`, {headers: {
        //     Accept: 'application/json'
        //   }
        // }).then((res)=>{
        //   window.location = "/"
        //   this.setState({
        //     btnText: "Done"
        //   })
        // }).catch((res)=>{
        //   window.location = "/"
        //   this.setState({
        //     btnText: "Done"
        //   })
        // });
    }
    return (
        <>{(loading) ? (<h5>Loading</h5>)   : (
            <div className="px-5 py-1 p-lg-0 bg-surface-secondary">
  <div className="d-flex justify-content-center">
    <div className="col-lg-5 col-xl-4 p-6 p-xl-20 position-fixed start-0 top-0 h-screen overflow-y-hidden bg-primary d-none d-lg-flex flex-column">
      {/* Logo */}
      <a className="d-flex" href="#">
        <img
          src="https://i.ibb.co/52NvQB3/2462345.png"
          className="h-10"
          alt="..."
        />
        <h5 style={{marginLeft:'10px'}}> FINder</h5>
       
      </a>
      {/* Title */}
      <div className="mt-5 mb-10">
        <h1 className="ls-tight font-bolder display-6 text-white mb-5">
          Just One More Step
        </h1>
        <p className="text-white text-opacity-80">
         Confirm on this final step to access your profile.After this you will get initally matches based upon financial taste.
        </p>
      </div>
      {/* Circle */}
    
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="red" viewBox="0 0 24 24" className="w-56 h-56 position-absolute bottom-0 end-20 transform translate-y-1/3 rotate-60"  transform='rotate(45)'><path d="M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"/></svg>
        
    </div>
    <div className="col-12 col-md-9 col-lg-7 offset-lg-5 border-left-lg min-h-lg-screen d-flex flex-column justify-content-center py-lg-1 px-lg-20 position-relative">

      <div className="row">
        <div className="col-lg-10 col-md-10 col-xl-10 mx-auto ms-xl-0">
          <div className="mt-10 mt-lg-5 mb-6 d-flex align-items-center d-lg-block">
            <span className="d-inline-block d-lg-block h1 mb-lg-6 me-3">
              👋
            </span>
            <h2 className="ls-tight font-bolder h3">Thank You, You details have been saved successfully</h2>

            
          </div>
          <div>
          <div className="card">
 
  <div className="p-2">
    <img
      alt="..."
      src="https://pixabay.com/get/g9ae3f281ae4c1d7c41993f8a5c8e5cc07844fdd66e1eeac0431ff78ad805b64a7108c77125aeda51b78881f124ad536ee2a2dc2c6cc3618e294ab6dba6afa581c39e87fe58fa762b0147e44e1e4d37c0_1920.jpg"
      width="200px"
      height="100px"
      className="card-img"
    />
  </div>
 
  <div className="card-body" style={{justifyContent:'center'}}>
  
    <h3 className="h4 tex-center">Click to visit your profile</h3>
  
    
    <p className="mt-4 mb-6">
      {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ornare pretium
      placerat ut platea... */}
    </p>
    <Link to={`/user/${userId}`} >
    <button  className="btn btn-sm btn-primary" style={{marginLeft:'70px'}}>
     {btnText}
    </button>
  </Link>
  </div>
</div>

          </div>
        
         
        
        </div>
      </div>
    </div>
  </div>
</div>
        )}
        </>
    )
}

export default ConfirmRegistration
